'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapInDispatch = undefined;

var _isObject2 = require('lodash/isObject');

var _isObject3 = _interopRequireDefault(_isObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var wrapInDispatch = exports.wrapInDispatch = function wrapInDispatch(dispatch, _ref) {
  var method = _ref.method,
      args = _ref.args,
      types = _ref.types;

  dispatch({
    type: (0, _isObject3.default)(types[0]) ? types[0].type : types[0],
    payload: (0, _isObject3.default)(types[0]) ? types[0].payload : { args: args }
  });
  return method.apply(undefined, _toConsumableArray(args)).then(function (val) {
    dispatch({
      type: types[1],
      payload: val
    });
    return val;
  }).catch(function (err) {
    dispatch({
      type: types[2],
      payload: err
    });
    return Promise.reject(err);
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/react-redux-firebase/es/utils/actions.js
// module id = 1189
// module chunks = 0